module.exports = __webpack_public_path__ + "img/show2.bc951542.jpg";